import React from 'react';
import { CSVLink } from 'react-csv'
import PropTypes from 'prop-types'

class DataExportButton extends React.Component {

	static propTypes = {
		mapDataToCSV: PropTypes.func.isRequired,
		mapDataToCSVFilename: PropTypes.func,
		data: PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.object,
		]),
		// filename is ignored if mapDataToCSVFilename is included
		filename: PropTypes.string
	}

	render() {
		const { 
			data, 
			mapDataToCSV, 
			mapDataToCSVFilename,
			filename,
			...props
		} = this.props;

		const hasData = Boolean(Object.keys(data).length);

		if(!hasData) return '';

		return (
			<CSVLink 
				className="CSVDownloadButton"
				data={mapDataToCSV(data)}
				filename={
					mapDataToCSVFilename
						? mapDataToCSVFilename(data)
						: filename ? filename : 'data-export.csv'
				}
				>
				<button type="button" className="btn btn-primary" {...props}>Export CSV</button>
			</CSVLink>
		)
	}
}

export default DataExportButton;


// WEBPACK FOOTER //
// ./src/components/DataExportButton/DataExportButton.jsx